import { MegaphoneIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchReal } from "../utils/fetch";

function Announcements() {
  const [announcementss, setAnnouncementss] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchReal("/announcement/all-announcements?limit=3")
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.success) {
          const anns = data.announcements;
          const r = [];
          anns.map((ann) => {
            const render = {
              ...ann,
              date: ann.updatedAt,
              url: `/announcements/view/${ann.id}`,
            };
            r.push(render);
            return r;
          });
          setAnnouncementss(r);
        }
      });
  }, []);

  return (
    <div className="tw-hidden lg:tw-block tw-bg-cover tw-h-fit tw-overflow-y-auto tw-py-4 tw-px-3 tw-rounded-lg sm:tw-w-72 tw-w-44 tw-float-right -tw-z-50">
      <ul className="tw-flex tw-flex-col -tw-mb-px tw-text-sm tw-font-medium tw-text-center tw-text-gray-500 tw-overflow-x-hidden">
        <li className="tw-mr-2 tw-flex tw-flex-row tw-items-center tw-border-b-2 tw-border-sky-700 tw-mb-6 tw-p-2 tw-shadow-md tw-rounded-lg tw-shadow-slate-200">
          <MegaphoneIcon className="tw-mr-2 tw-w-6 tw-h-6 tw-text-black" />
          <span className="tw-text-lg tw-font-bold tw-text-black">
            Announcements
          </span>
          <span className="tw-ml-1">
            <Link
              to="/announcements"
              className="tw-underline tw-decoration-sky-700 tw-text-sky-700 tw-text-xs hover:tw-decoration-double hover:tw-text-sky-800 hover:tw-decoration-sky-800"
            >
              See All
            </Link>
          </span>
        </li>
        {!loading &&
          announcementss.length > 0 &&
          announcementss.map((announcement) => (
            <li
              key={announcement.id}
              className="tw-bg-gradient-to-br tw-mb-3 tw-from-white/70 tw-border tw-border-gray-300 tw-via-gray-200/70 tw-to-white/70 tw-backdrop-blur-sm sm:tw-p-4 tw-p-3 tw-rounded-lg tw-shadow-lg tw-mr-2"
            >
              <Link
                to={announcement.url}
                className="tw-text-xl tw-text-left tw-text-sky-700 tw-font-bold tw-underline hover:tw-decoration-double hover:tw-cursor-pointer hover:tw-text-sky-800 tw-flex tw-flex-wrap tw-w-full"
              >
                {announcement.title}
              </Link>
              <p className="tw-text-left">{announcement.date}</p>
              <div className="tw-border-b-2 tw-mb-1"></div>
              <p className="tw-text-left tw-text-lg tw-prose tw-w-full">
                {announcement.description}
              </p>
              {/* <Link to={announcement.url} className="tw-flex tw-flex-wrap tw-w-full">
                <div className="tw-transition-all tw-ease-in-out tw-duration-300 tw-group tw-flex tw-flex-row tw-bg-sky-700 tw-p-2 tw-rounded hover:-tw-translate-y-1 hover:tw-bg-sky-800 hover:tw-shadow-lg">
                  <span className="tw-text-white">Read</span>{" "}
                  <ArrowRightIcon className="tw-w-5 tw-h-5 tw-text-white" />
                </div>
              </Link> */}
            </li>
          ))}
        {!loading && announcementss.length < 1 && (
          <p className="tw-mr-2">No announcements.</p>
        )}
        {loading && <p className="tw-mr-2">Loading...</p>}
      </ul>
    </div>
  );
}

export default Announcements;
